import { render, staticRenderFns } from "./WarningAlert.vue?vue&type=template&id=256fd0e0"
import script from "./WarningAlert.vue?vue&type=script&lang=ts"
export * from "./WarningAlert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports